<template>
  <div class="binary-choice">
    <button id="binary-no" class="binary-choice__item button" v-on:click="choose(false)">
      {{noMessage}}
    </button>
    <button id="binary-yes" class="binary-choice__item button button--encourage" v-on:click="choose(true)">
      {{yesMessage}}
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      noMessage: { type: String, default: 'no' },
      yesMessage: { type: String, default: 'yes' },
    },
    methods: {
      choose(choice) {
        this.$dispatch('choose', choice);
      },
    },
  };
</script>

<style lang="scss">
  .binary-choice {
    display: flex;
    &__item {
      width: 50%;
    }
  }
</style>


/** WEBPACK FOOTER **
 ** BinaryChoice.vue?5ec426c9
 **/